import { Component, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, TokenService } from '@demoiselle/security';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeader {

  user;
  connectedUsers = [];
  totalUsers = 0;

  constructor(
    private el: ElementRef,
    private router: Router,
    private authService: AuthService,
    private tokenService: TokenService) { }

  ngOnInit(): void {
    // wait for the component to render completely
    const nativeElement: HTMLElement = this.el.nativeElement;
    const parentElement: HTMLElement = nativeElement.parentElement;

    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }

    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);

  }

  ngAfterViewInit() {
    if (this.isLoggedIn()) {
    }
  }

  isLoggedIn() {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }

  private handleCountEvent(data) {
    this.totalUsers = data;
  }

  private handleListEvent(data) {
    const users = JSON.parse(data).map(user => {
      const obj = user.split(':');
      let index = 0;
      return {
        name: obj[index++],
        email: obj[index++],
        role: obj[index++],
        // geo: obj[index++],
      };
    });
    this.connectedUsers = users;
    // console.debug({ users });
  }
}



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/shared/layout/components/app-header/app-header.component.ts